export default "__VITE_ASSET__DNsKoaVS__"